
<app-form-input *ngIf="step8?.getmotclef"  [label]="step8?.getmotclef"
	[name]="getUid() + '_SepAtt_motClef'" [parentForm]="parentForm" [disabled]="disabled"
	[type]="'chips'" [rule]="'required'" [errorMessage]="{'required' : 'ctr_vide'}" [value]="motsClef?.motClef"
	[autoCompleteType]="'MOT_CLEF'" [autoCompleteTypeIndex]="0" [infoBulle]="infobulle">
</app-form-input>

